import Announcement from './Announcement';
import CompareTool from './CompareTool';
import ContactUs from './ContactUs';
import DealerSuccess from './DealerSuccess';
import GuidedSalesTool from './GuidedSalesTool';
import Landing from './Landing';
import Login from './Login';
import Manuals from './Manuals';
import Brochures from './Brochures';
import Logos from './Logos';

import MyAGIRep from './MyAGIRep';
import NotFound from './NotFound';
import PricingHelper from './PricingHelper';
import Terms from './Terms';
import WarrantyClaimConfirmation from './WarrantyClaimConfirmation';
import WarrantyClaims from './WarrantyClaims';

export {
  Announcement,
  CompareTool,
  ContactUs,
  DealerSuccess,
  GuidedSalesTool,
  Landing,
  Login,
  Manuals,
  Brochures,
  Logos,
  MyAGIRep,
  NotFound,
  PricingHelper,
  Terms,
  WarrantyClaimConfirmation,
  WarrantyClaims
};



// WEBPACK FOOTER //
// ./src/pages/index.js